import { createForm } from '../../../factories'

export default createForm(['message'])


// WEBPACK FOOTER //
// ./src/store/modules/bioreq/forms/match.js